import { createSlice } from "@reduxjs/toolkit";
// `parseCustomerRecord` is no longer imported here — it moved to customerHelpers/shared.ts on
// 2026-09-05 with the reducer that used it, so this file needs no variant-pinned import at all.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedCustomerState } from "./shared";

export interface CustomerState extends SharedCustomerState {
  setSyncData: boolean,
  showBackorderModal: boolean,
}

const initialState: CustomerState = {
  ...sharedInitialState,
  setSyncData: false,
  showBackorderModal: false,
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    ...sharedReducers,
    // ── Web-only. Every reducer this slice shares with mobile now lives in ./shared —
    //    `setCustomerDataSuccess` and `getCustomerRecord` were the last two to converge
    //    (2026-09-05), and web gained the empty-address filter in the process.
    updateCustomerSlice: (state, action) => {
      return action.payload;
    },
    setSyncData: (state,action) => {
      state.setSyncData = action.payload
    },
    saveBackOrderShowModal: (state, action) => {
      state.showBackorderModal = action.payload
    }
  },
  // Both bodies are empty in the app source — the cases exist but reset nothing.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {

      })
      .addCase(supportLogout, (state) => {

      });
  },
});

export const {
  getCustomerData,
  getCustomerDataFail,
  setCustomerDataSuccess,
  setExternalLoyaltyData,
  getCustomerRecord,
  getCustomerDetailsUsingMobile,
  getCustomerSummary,
  getCustomerSummaryRecord,
  authenticateCustomerData,
  authenticateCustomerDataSuccess,
  authenticateCustomerDataFailure,
  customerRecordNotFound,
  resetCustomerRecordNotFound,
  resetCustomerStore,
  toggleCustomerNum,
  saveCustomerInfo,
  getDetailedCustomerInfo,
  updateCustomerSlice,
  setSyncData,
  saveBackOrderShowModal
} = customerSlice.actions;
export default customerSlice.reducer;
